/* eslint-disable @typescript-eslint/no-deprecated */

import React from 'react'
import styled from 'styled-components'
import { Toggle, ToggleProps } from '../../buildingBlocks/Toggle'
import { Caption } from '../../styles'

interface Props extends ToggleProps {
  caption: string
}

export const ToggleSwitch: React.FC<Props> = ({ caption, active, onClick, disabled, toggleName }) => (
  <>
    <ToggleSwitchContainer>
      <Toggle disabled={disabled} active={active} onClick={() => onClick()} toggleName={toggleName} />
      <ToggleCaption onClick={() => onClick()}>{caption}</ToggleCaption>
    </ToggleSwitchContainer>
    <Border />
  </>
)

const ToggleSwitchContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  user-select: none;
`

const ToggleCaption = styled(Caption)`
  cursor: pointer;
  margin-left: 2rem;
`

const Border = styled.div`
  border-bottom: 0.2rem solid ${({ theme }) => theme.colors.grey.light};
  margin: 2rem 0;
`
